export default __webpack_public_path__ + "static/media/model-s.0d203c30.jpg";